<template>
    <div class="prp-table-container">
        <h5>Resultados de Votos en:</h5>
        <h1>{{ data.desc_centro }} - {{ data.centro }}</h1>
        <v-row> </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-data-table
                    :headers="headers"
                    :items="divisiones"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    class="elevation-1"
                >
                    <template v-slot:item.porcentaje="{ item }">
                        <v-chip
                            :color="
                                getPorcentage(item.votantes, item.padron) < 16
                                    ? 'red'
                                    : getPorcentage(
                                          item.votantes,
                                          item.padron
                                      ) < 40
                                    ? 'yellow'
                                    : 'green'
                            "
                            dark
                            small
                        >
                            {{ getPorcentage(item.votantes, item.padron) }}%
                        </v-chip>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props: ['data', 'colores', 'hexa_colors'],
    data: () => ({
        loading: false,
        showDivisiones: false,
        seriesparticipacion: [],
        seriesvotes: [],
        divisiones: [],
        tempData: [],
        headers: [
            {
                text: 'Division',
                align: 'start',
                sortable: false,
                value: 'desc_ures',
            },
            {
                text: 'Padron',
                align: 'start',
                sortable: false,
                value: 'padron',
            },
            {
                text: 'Votantes',
                align: 'start',
                sortable: false,
                value: 'votantes',
            },
            {
                text: 'Porcentaje',
                align: 'start',
                sortable: false,
                value: 'porcentaje',
            },
            // {
            //     text: 'Planilla Participante',
            //     align: 'start',
            //     sortable: false,
            //     value: 'name',
            // },
            // { text: 'Votos Ejercidos', value: 'total' },
        ],
        chartOptionsvotes: {
            chart: {
                width: 380,
                type: 'bar',
            },

            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
        },
        chartOptionsparticipacion: {
            chart: {
                width: 380,
                type: 'pie',
            },
            //colors : ['#2E93fA','#90BBD8'],
            //labels : ['Votantes','Faltantes'],
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
        },
    }),
    methods: {
        loadOptions: function() {
            console.log(this.data.divisiones);
            this.divisiones = this.data.divisiones;
        },
        toggleDivisiones: function() {
            this.showDivisiones = !this.showDivisiones;
        },
        getPorcentage: function(votantes, padron) {
            return Math.floor((votantes / padron) * 100);
        },
    },
    created() {
        this.loadOptions();

        // Fill the tempData array with the data from props and map the values but votantes and porcentaje are random numbers
        // this.tempData = this.data.divisiones.map(item => {
        //     return {
        //         ures_pred: item.ures_pred,
        //         padron: item.padron,
        //         votantes: item.votantes,
        //         porcentaje: Math.floor(Math.random() * 100),
        //     };
        // });
    },
};
</script>
